import { orpcErrorMessage } from './orpc-errors';

/**
 * The person's RudderStack sign-in ended: the server could not get a fresh ID token for them
 * (`withIdTokenRetry`, `rudderstack_reauth_required`). It arrives as an `UNAUTHORIZED` whose message is the code, so
 * this tells it apart from every other `UNAUTHORIZED`, which keeps the text it has today.
 */
export function isRudderstackReauthRequired(err: unknown): boolean {
  return orpcErrorMessage(err, '').includes('rudderstack_reauth_required');
}

/** What the page says when an action needs a new RudderStack sign-in (ACT2-1124, F12). */
export const RUDDERSTACK_REAUTH_MESSAGE = 'Your RudderStack sign-in has ended. Sign in again to continue.';

/** The label of the action that offers the sign-in. */
export const RUDDERSTACK_REAUTH_ACTION = 'Sign in again';
